import { MetaGamesEventType } from '../../../../dto/metagames.types';
import type { CoinType } from '../../../../stores/cointype/CoinTypeStore';
import type { PlayerQuest } from '../../../../stores/quest/types';
import type { Tournament, TournamentOfChampions } from '../../../../stores/tournament/types';
import { selectTournamentDialogVariant } from '../../../Dialogs/TournamentDialog/selectTournamentDialogVariant';

/**
 * A tournament (regular, teams or a TOC round) is running on the current coin and the tournament dialog has a
 * variant to render for it. True even before the player joins: the dialog lands them on the join screen.
 */
export function isTournamentOpenForPlayer({
  currentTournament,
  coinType,
  tournamentOfChampions,
  shouldRenderTocDialog,
  tocOwnsSlot,
}: {
  currentTournament: Tournament | null;
  coinType: CoinType;
  tournamentOfChampions: TournamentOfChampions | null;
  shouldRenderTocDialog: boolean;
  tocOwnsSlot: boolean;
}): boolean {
  if (!currentTournament || currentTournament.status !== 'ongoing') return false;
  if (!currentTournament.leaderboards[coinType.toLowerCase() as 'gc' | 'sc']) return false;
  return (
    selectTournamentDialogVariant({ currentTournament, tournamentOfChampions, shouldRenderTocDialog, tocOwnsSlot }) !==
    null
  );
}

/** Same gate as the lobby quest widget (useQuestWidgets). */
export function isChaseAvailable({
  questsFlag,
  currentPlayerQuest,
}: {
  questsFlag: boolean;
  currentPlayerQuest: PlayerQuest | null;
}): boolean {
  return questsFlag && currentPlayerQuest != null;
}

/** The CTA metagames routed through MetagamesStore. */
export function selectStoreMetagameCtaAvailability({
  metagamesEnabled,
  isMetagameAvailable,
  isCardWarEnded,
}: {
  metagamesEnabled: boolean;
  isMetagameAvailable: (kind: MetaGamesEventType) => boolean;
  isCardWarEnded: boolean;
}): { prizeDrop: boolean; cardWar: boolean } {
  return {
    prizeDrop: metagamesEnabled && isMetagameAvailable(MetaGamesEventType.PRIZE_DROP),
    // Like the lobby widget (useMetagameWidgets): x on Do-It-Again ends the event for this player on this coin.
    cardWar: metagamesEnabled && !isCardWarEnded && isMetagameAvailable(MetaGamesEventType.CARD_WAR),
  };
}
